import styled from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils';
import { NavLink } from 'react-router-dom';

export const Wrapper = styled.div`
  padding-top: 88px;
`;

export const Container = styled.div``;

export const Heading = styled.div`
  font-size: 16px;
  padding: ${({ email }) => email ? '44px 0 0 0' : '0 20px 24px'};
  text-align: center;

  > a {
    color: #007AFF;
    text-decoration: underline
  }
`;

export const Agree = styled.p`
  color: ${colors.BODY};
  font-size: 12px;
  font-weight: 400;

  a {
    color: ${colors.MAIN_COLOR};
    text-decoration: underline;
  }
`

export const Demo = styled(NavLink)`
  display: block;
  font-family: poppins, sans-serif;
  font-weight: bold;
  margin: 2em 0 0 0;
  text-align: center;
`

export const ButtonGroup = styled.div`
  padding-top: 80px;
  text-align: center;

  > button {
    padding: 10px 32px;
  }
`;

export const StyledForm = styled.form`
  margin-bottom: 50px;
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  padding: 0 20px 30px;
`;

export const CheckboxLabel = styled.div`
  > a,
  > a:hover {
    text-decoration: underline;
  }
`;

export const FormButtonGroup = styled.div`
  text-align: center;
  padding-top: 35px;

  > button {
    width: 256px;
  }

  > span {
      margin: 0 15px 0;
      color: ${colors.BODY};
      font-size: 10px;
      line-height: 18px;
      text-align: right;
  }
  > a {
      color: ${colors.MAIN_COLOR};
      font-size: 12px;
      line-height: 17px;
    }
`;

export const ContactUs = styled.div`
  position: absolute;
  height: 38px;
  bottom: 0px;
  background-color: ${colors.WHITE};
  font-size: 12px;
  padding: 0 20px;

  > a,
  > a:hover {
    color: ${colors.MAIN_COLOR};
  }
`

export const CheckboxWrapper = styled.div`
  padding: 0 20px;
  > div {
    > label {
      > input {
        &:checked + div {
          background: ${colors.BUTTON_BG};
          border: solid #00B2FF 1px;
        }
        &:checked + div:after {
          content: '';
          display: block;
          position: relative;
          left: 5px;
          width: 4px;
          height: 12px;
          border: solid ${colors.WHITE};
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
      }

    }
  }
`;

export const A = styled.a`
  // font-weight: bold;
  cursor: pointer;
  color: ${colors.MAIN_COLOR}!important;
`;



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/styledComponents.js